import type { Messages } from "../fr";

export const reports: Messages["reports"] = {
  list: {
    pageTitle: "Passes — Hune",
    subject: "your passes",
    workspaceBanner: { before: "Passes of the client workspace ", after: " (read-only)." },
    eyebrow: "History",
    lede: "Every pass of the agent is kept with its sources and the leads it added. The pipeline is where you work; these reports are its verifiable record.",
    title: "Passes.",
    titleFor: (name: string) => `Passes — ${name}.`,
    emptyWorkspace: "No passes recorded for this client workspace.",
    empty: "No passes recorded yet.",
    firstPass: "Run a first pass",
    tableLabel: "Recorded passes",
    columns: { pass: "Pass", startedAt: "Started", status: "Status", report: "Report" },
    source: { radar: "monitoring", manual: "manual" },
    open: "View",
    openLabel: "View the report",
  },
  detail: {
    pageTitle: "Report — Hune",
    subject: "this report",
    back: "Passes",
    notFound: {
      title: "Report not found.",
      body: "This pass doesn’t exist, or it isn’t accessible from your account.",
      label: "See passes",
    },
    failed: (reason: string) => `This analysis failed: ${reason}.`,
    unknownReason: "unknown reason",
    unreadable: "The saved report can’t be read. Run a new analysis.",
    pending: "This analysis isn’t finished. Check back a little later.",
  },
  report: {
    done: "Analysis complete",
    opportunities: "Selected opportunities",
    averagePriority: "Average priority",
    prioritySegment: "Priority segment",
    strategy: "Research strategy",
    strategyTitle: "Why these signals?",
    target: "Target",
    targetTitle: "The context to focus on",
    decisionMaker: "Decision-maker",
    desiredProgress: "Desired progress",
    favorableEvent: "Favorable event",
    priorities: "Priorities",
    prioritiesTitle: "The conversations to open at the right time.",
    clue: "Observed signal",
    relevance: "Relevance",
    momentum: "Current window",
    draft: "Message draft",
    toVerify: (note: string) => `To verify: ${note}`,
    trends: "Recurring trends",
    trendsTitle: "What’s taking shape in the market.",
    nextSequence: "Next sequence",
    caveats: "Usage notes",
    score: { strong: "Strong", promising: "Promising", toConfirm: "To confirm" },
  },
  view: {
    copyLink: "Copy link",
    exportPdf: "Export as PDF",
    exportFailed: "The PDF export failed.",
    exportFailedRetry: "The PDF export failed. Try again in a moment.",
    defaultFilename: "hune-report.pdf",
    print: "Print",
    copy: "Copy",
    sourceDetails: "View the source and analysis",
    observation: "Observation",
    contactRoute: "Contact route",
    feedback: {
      label: (organization: string) => `Relevance of ${organization}`,
      prompt: "Relevant?",
      relevant: "Relevant opportunity",
      offTarget: "Off-target opportunity",
    },
  },
  pdf: {
    subject: (url: string) => `Market analysis — ${url}`,
    quote: (text: string) => `“${text}”`,
    source: "Source",
    whoToContact: "Who to contact",
    filenameFallback: "report",
  },
  errors: {
    signIn: "Please log in.",
    signInToExport: "Log in to export a report.",
    notFound: "Report not found.",
    invalidId: "Invalid report ID.",
    notFoundOrPending: "Report not found, or the analysis isn’t finished.",
    unreadable: "The saved report can’t be read.",
  },
};
